/* eslint-disable import/prefer-default-export, react/prop-types */
import React from "react";
import Root from "./src/Root";
import Site from "./src/Site";
import { AuthContextProvider } from "@parallelpublicworks/understory-auth";

export const wrapRootElement = ({ element }, options) => {
	return <Root options={options}>{element}</Root>;
};

export const wrapPageElement = ({ element, props }, options) => {
	return (
		<AuthContextProvider>
			<Site element={element} props={props} options={options} />
		</AuthContextProvider>
	);
};
